/* ============================================================
   NK — preselect the multi-pack. Added 27 Sep 2026.
   See claude/offer-decision-bogo-vs-pack-of-2-27-sep-2026.md

   Why: Pack of 1 was preselected, so the default add-to-cart was
   Rs 1,799 (CAC ceiling Rs 989). Pack of 2 carries the free
   So Nysinn lotion and a CAC ceiling of Rs 2,013. Nobody is
   forced — only the path of least resistance changes.

   How: we do not duplicate the section's logic. We click the
   "best" option so the section's own pick() runs, which sets
   is-on, checks the input, updates qty, the displayed total,
   window.NKPack, and the sticky bar's price. Verified live:
   sticky goes Rs 1,799 -> Rs 3,598 on its own.

   No-ops safely when a product has only one pack (the gift
   product's own page, single-variant items).
   ============================================================ */
(function () {
  function preselect() {
    var roots = document.querySelectorAll('[id^="nkps-"]');
    for (var i = 0; i < roots.length; i++) {
      var best = roots[i].querySelector('.nkps__opt--best');
      if (best && !best.classList.contains('is-on')) {
        best.click();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselect);
  } else {
    preselect();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', preselect);
})();
